import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { EnvironmentService } from 'src/app/services/environment.service';
import { FacilityConfig, PricingConfig } from 'src/environments/environment.interface';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})
export class PricingComponent implements OnInit {
  
  settings: FacilityConfig;
  pricingConfig: PricingConfig;
  carouselSlides: OwlOptions = {
    // items: 1,
    // nav: true,
    // margin: 10,
    loop: true,
    dots: false,
    autoplay: true,
    smartSpeed: 500,
    animateIn: 'fadeIn',
    animateOut: 'fadeOut',
    autoplayHoverPause: false,
    // navText: [
    //   "<i class='fa-solid fa-chevron-left'></i>",
    //   "<i class='fa-solid fa-chevron-right'></i>"
    // ],
    responsive: {
      0:{
          items:1
      },
      600:{
          items:2
      },
      1000:{
          items:3
      }
    }
  }

  carouselSource = [
    {
      url: '/assets/images/df/pricing/Picture_01.jpg',
    },
    {
      url: '/assets/images/df/pricing/Picture_02.jpg',
    },
    {
      url: '/assets/images/df/pricing/Picture_03.jpg',
    },
    {
      url: '/assets/images/df/pricing/Picture_04.jpg',
    },
    {
      url: '/assets/images/df/pricing/Picture_05.jpg',
    },
    {
      url: '/assets/images/df/pricing/Picture_06.jpg',
    },
  ];

  constructor(
    private _environmentService: EnvironmentService
  ) { 
    this.settings = this._environmentService.getFacilityConfig();
    this.pricingConfig = this.settings.homePage.pricing;
  }

  ngOnInit(): void {
  }

  onClick(navPage: string) {

  }

  getSlideImage(slideNo: number) {
		if (this.settings.homePage.banner.slides[slideNo].slideImage) {
		return this.settings.homePage.banner.slides[slideNo].slideImage;
		}
		else {
		return this.settings.homePage.banner.slides[0].slideImage;
		}
	}

}
